/**
 * 错误处理中间件
 */

import { Request, Response, NextFunction } from 'express';
import { logger } from '../../utils/logger.js';
import { ApiError, ApiErrorCode } from '../types.js';

export function errorHandler(
  err: Error | ApiError,
  req: Request,
  res: Response,
  next: NextFunction
): void {
  // 记录错误
  logger.error('API Error:', {
    error: err.message,
    stack: err.stack,
    path: req.path,
    method: req.method,
    body: req.body,
    query: req.query,
  });

  // 处理 API 错误
  if (err instanceof ApiError) {
    res.error(err.code, err.message, err.statusCode, err.details);
    return;
  }

  // 处理验证错误
  if (err.name === 'ValidationError') {
    res.error(
      ApiErrorCode.VALIDATION_ERROR,
      'Validation failed',
      400,
      err.message
    );
    return;
  }

  // 处理其他错误
  const statusCode = (err as any).statusCode || 500;
  const message = err.message || 'Internal server error';
  
  res.error(
    ApiErrorCode.INTERNAL_ERROR,
    message,
    statusCode
  );
}